import { AxiosResponse } from 'axios';
import { axiosRequest } from '@/common/api/instance';
import { CreateOrdersBody, OrderClaim } from '@/types/api/orders.types';
import { Response as ApiResponse } from '@/types/api/response.types';

const resource = '/claims';

export const createClaims = async (
  data: CreateOrdersBody,
): Promise<AxiosResponse<ApiResponse<OrderClaim[]>>> => {
  return axiosRequest().post(`${resource}`, data);
};
